import { Auditable } from "..";

export interface SurgeryType extends Auditable {
    name: string;
}

// compare to API/Resources/SurgeryTypes/DefaultSurgeryTypes.cs
// getSurgeryTypeAbbreviation.ts uses this enum
export enum SurgeryTypes {
    PK = "PK",
    EK_DSEK_DSAEK_DLEK = "EK - DSEK DSAEK DLEK",
    EK_DMEK = "EK - DMEK",
    ALK_DALK = "ALK - DALK",
    ALK_OTHER = "ALK - Other",
    K_PRO = "K-Pro",
    KLAL = "KLAL",
    GLAUCOMA_SHUNT_PATCH = "Glaucoma shunt patch",
    ENCULEATION = "Enucleation",
    LID_RETRACTION = "Lid retraction",
    OTHER_KERATOPLASTY = "Other Keratoplasty (experimental)",
    OTHER = "Other surgical uses",

    WHOLE_SCLERA = "Whole Sclera",
    HALF_SCLERA = "Half Sclera",
    QUARTER_SCLERA = "Quarter Sclera",
    WHOLE_GLYCEROL_PLUS_CORNEA = "Whole Glycerol Plus Cornea",
    HALF_GLYCEROL_PLUS_CORNEA = "Half Glycerol Plus Cornea",
    SPLIT_CORNEA = "Split-Thickness Half-moon Sterile Cornea",
}
